import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import LoanDetails from './LoanDetails';
import BorrowerDetails from './BorrowerDetails';
import PersonalDetails from './PersonalDetails';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = {
  form: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}

class OnlineFormDetails extends React.Component {
  state = {
    tabIndex: 0,
  };

  handleChange = (event, tabIndex) => {
    this.setState({ tabIndex });
  };

  numOfPersons = () => (this.props.application.form.numberOfPersons);

  appType = () => (this.props.application.appType);

  personCount = () => (this.appType() === 'referral' ? 1 : parseInt(this.numOfPersons(), 10));

  colWidth = () => (this.appType() === 'referral' ? 4 : parseInt(12/this.numOfPersons(), 10))

  renderPersonalDetails = () => {
    return (
      <Grid container className={this.props.classes.form} spacing={16}>
        {
          _.range(3).map((i) => {
            return (
              <Grid item xs={this.colWidth()} key={`person${i+1}`}>
                <Typography variant='subheading' color='secondary' gutterBottom>
                  {`Guarantor #${i+1}`}
                </Typography>
                <PersonalDetails person={`person${i+1}`}/>
              </Grid>
            )
          })
        }
      </Grid>
    );
  }

  render() {
    const { tabIndex } = this.state;
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            centered
            value={this.state.tabIndex}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            fullWidth
          >
            <Tab label="Loan Details" />
            <Tab label="Borrower Details" />
            <Tab label="Director/Guarantor Details" />
          </Tabs>
        </AppBar>
        <br/>
        {
          tabIndex === 0 && (
            <div>
              <Grid container spacing={16}>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <LoanDetails referrals={this.props.referrals} />
                </Grid>
                <Grid item xs={3}>
                </Grid>
              </Grid>
            </div>
          )
        }
        {
          tabIndex === 1 && (
            <div>
              <Grid container spacing={16}>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={6}>
                  <BorrowerDetails industry={this.props.industry}/>
                </Grid>
                </Grid>
                <Grid item xs={3}>
                </Grid>
            </div>
          )
        }
        {
          tabIndex === 2 && (
            <div>
              { this.renderPersonalDetails() }
            </div>
          )
        }
      </div>
    )
  }
}

export default withStyles(styles)(OnlineFormDetails);



// WEBPACK FOOTER //
// ./src/components/Applications/OnlineFormDetails.js